<div class="bio-holder" id="bioHolder">
  <textarea
    [(ngModel)]="bio"
    rows="1"
    (ngModelChange)="autoGrow()"
    id="textarea"
    maxlength="1000"
    placeholder="درباره من..."
  ></textarea>
</div>
